import React from "react";
import { CircularProgress, Grid } from "@mui/material";
import { ErrorAlert } from "components/alert/ErrorAlert";

interface LoadablePageProps {
  loading?: boolean;
  error?: Error;
}
export function LoadablePage({ loading, error, children }: React.PropsWithChildren<LoadablePageProps>) {
  return (
    <>
      {loading ? (
        <Grid sx={{ display: "flex", flexDirection: "column", alignItems: "center" }} size={3}>
          <CircularProgress />
          <p>Loading...</p>
        </Grid>
      ) : !error ? (
        children
      ) : (
        <ErrorAlert error={error} />
      )}
    </>
  );
}
